import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { locomotorasService } from '../../services/api';

function NivelBar({ valor, maximo, color, alerta }) {
  const pct = Math.min(100, (valor / maximo) * 100);
  const c = valor < alerta ? '#a32d2d' : color;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <div style={{ flex: 1, height: 6, background: '#f0f0f0', borderRadius: 3 }}>
        <div style={{ width: `${pct}%`, height: '100%', background: c, borderRadius: 3, transition: 'width 0.3s' }} />
      </div>
      <span style={{ fontSize: 12, color: c, fontWeight: 500, minWidth: 50, textAlign: 'right' }}>
        {valor?.toFixed(0)} L
      </span>
    </div>
  );
}

export default function Flota() {
  const [locomotoras, setLocomotoras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('todas');
  const navigate = useNavigate();

  useEffect(() => {
    locomotorasService.getAll()
      .then(r => setLocomotoras(r.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 40, color: '#888' }}>Cargando...</div>;

  const activas = locomotoras.filter(l => l.activa);
  const filtradas = filtro === 'todas' ? activas :
    filtro === 'exploradoras' ? activas.filter(l => l.tipo === 'exploradora') :
    activas.filter(l => l.tipo === 'ferrovial');

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 22, fontWeight: 500, margin: 0 }}>Flota</h2>
        <p style={{ fontSize: 13, color: '#888', marginTop: 4 }}>Estado actual de las locomotoras</p>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {[['todas', 'Todas'], ['exploradoras', 'Exploradoras'], ['ferrovial', 'Ferrovial']].map(([val, label]) => (
          <button key={val} onClick={() => setFiltro(val)} style={{
            padding: '7px 16px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 500,
            background: filtro === val ? '#1a1a1a' : '#f0f0f0',
            color: filtro === val ? '#fff' : '#555'
          }}>{label} {val === 'todas' ? `(${activas.length})` : val === 'exploradoras' ? `(${activas.filter(l => l.tipo === 'exploradora').length})` : `(${activas.filter(l => l.tipo === 'ferrovial').length})`}</button>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }}>
        {filtradas.map(l => (
          <div key={l.id} onClick={() => navigate(`/staff/locomotora/${l.id}`)}
            style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', padding: 16, cursor: 'pointer', transition: 'box-shadow 0.15s' }}
            onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'}
            onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: 16 }}>{l.numero}</div>
                <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                  {l.servicio_asignado ? l.servicio_asignado.codigo : 'Sin servicio'} · {l.tipo}
                </div>
              </div>
              <span style={{ fontSize: 11, background: '#f0f0f0', color: '#555', borderRadius: 20, padding: '3px 8px' }}>
                {l.km_actuales?.toLocaleString('es-ES')} km
              </span>
            </div>

            <div style={{ marginBottom: 8 }}>
              <div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>Combustible</div>
              <NivelBar valor={l.litros_combustible || 0} maximo={l.capacidad_combustible || 5000} color='#639922' alerta={l.capacidad_combustible * 0.2} />
            </div>

            {l.tiene_adblue && (
              <div style={{ marginBottom: 8 }}>
                <div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>AdBlue</div>
                <NivelBar valor={l.litros_adblue || 0} maximo={l.capacidad_adblue || 530} color='#378ADD' alerta={105} />
              </div>
            )}

            <div style={{ display: 'flex', gap: 12, marginTop: 10, paddingTop: 10, borderTop: '1px solid #f0f0f0', fontSize: 12, color: '#888' }}>
              <span>⏱ {l.horas_motor?.toFixed(0) || 0} h</span>
              {l.ubicacion && <span>📍 {l.ubicacion}</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
